'use client'

import {
  parseAsBoolean,
  parseAsInteger,
  parseAsString,
  useQueryStates,
} from 'nuqs'

export const useSearchParams = (): any => {
  const [searchParams, setSearchParams] = useQueryStates({
    isCheckout: parseAsBoolean,
    customerId: parseAsString,
    cartId: parseAsString,
    productFilterId: parseAsInteger,
    orderId: parseAsInteger,
    orderReturnId: parseAsString,
    showMobileCart: parseAsBoolean,
  })

  return {
    ...searchParams,
    setSearchParams,
  }
}
